import React, { PureComponent } from 'react'
import { injectIntl, FormattedHTMLMessage } from 'react-intl'

import { scrollTo } from './services/utils'

import Language from './Language'

import './Languages.css'

export default injectIntl(
  class Languages extends PureComponent {
    componentDidUpdate(prevProps) {
      const { languages } = this.props
      if (languages !== prevProps.languages) {
        scrollTo(this.element)
      }
    }
    render() {
      const { languages, language, onChanged } = this.props
      if (languages.length > 0) {
        return (
          <div ref={el => (this.element = el)} className="cm-languages">
            <h2 className="cm-languages--title">
              <FormattedHTMLMessage id="teaching_language" />
            </h2>
            <div className="cm-languages--outer">
              {languages.map(l => (
                <Language
                  key={l.code}
                  language={l}
                  selected={language === l.code}
                  onChanged={onChanged}
                />
              ))}
            </div>
          </div>
        )
      }
    }
  }
)



// WEBPACK FOOTER //
// ./src/Languages.js